import { RootState } from "src/redux/store";

export const selectActiveMenu = (state: RootState) => state.activeMenu;
